import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';
import { computed }    from 'mobx';

/**
 * Le JSON de TOUTES les cartes du projet en une requête, tel que l'aperçu le consomme. Même forme de
 * réponse que `MapJsonModel` : un unique attribut `json`, sérialisé.
 */
@doc.path('/projects/{id}/json')
export default class ProjectJsonModel extends MapServiceModel {
	@computed get json() {
		return JSON.parse(this.get('json'));
	}
}
